import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@4.3.12_next@15.3.2_@babel+core@7.28.4_react-dom@19.2.0_react@19.2.0__react@19_4e7533c42625a6d2ff60a44070e4fe3f/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["SwiperCurvedCarousel"] */ "/app/src/pages/home/ui/curverd-carousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImpactSection"] */ "/app/src/pages/home/ui/impact-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IntroHero"] */ "/app/src/pages/home/ui/intro-hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LastBanner"] */ "/app/src/pages/home/ui/last-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NoticePopup"] */ "/app/src/pages/home/ui/notice-popup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Plan"] */ "/app/src/pages/home/ui/plan.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollCircleMotion"] */ "/app/src/pages/home/ui/scroll-circle-motion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Software"] */ "/app/src/pages/home/ui/software.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion","AccordionItem","AccordionTrigger","AccordionContent"] */ "/app/src/shared/ui/accordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PlanBanner"] */ "/app/src/shared/ui/plan-banner.tsx");
